import { LIBRARY, ATTENDEE_MATERIALS_LIBRARY, LIBRARY_MEDIA_CONTENT } from 'queries/library';
import { makeApolloClient, logError } from '../util';
import {
	UPLOAD_LIBRARY_MEDIA,
	CREATE_LIBRARY,
	DELETE_LIBRARY,
	UPDATE_LIBRARY,
	FETCH_LIBRARY,
	CLEAR_LIBRARY,
	UPDATE_CHILD_LIBRARY,
	ADD_CHILD_LIBRARY,
	DELETE_CHILD_LIBRARY,
	ADD_GROUPS_TO_LIBRARY,
	REMOVE_GROUPS_FROM_LIBRARY,
} from './actionTypes';

export const createLibrary = (library, from) => ({
	type: CREATE_LIBRARY,
	library,
	from,
});

export const updateLibrary = (library, from) => ({
	type: UPDATE_LIBRARY,
	library,
	from,
});

export const deleteLibrary = ({ id: libraryID }, from) => ({
	type: DELETE_LIBRARY,
	libraryID,
	from,
});

export const uploadLibraryMedia = (media, from) => ({
	type: UPLOAD_LIBRARY_MEDIA,
	media,
	from,
});

const fetchLibrary = (library, from) => ({
	type: FETCH_LIBRARY,
	library,
	from,
});

export const clearLibrary = from => ({
	type: CLEAR_LIBRARY,
	from,
});

export const addChildLibrary = library => ({
	type: ADD_CHILD_LIBRARY,
	library,
});

export const updateChildLibrary = library => ({
	type: UPDATE_CHILD_LIBRARY,
	library,
});

export const deleteChildLibrary = libraryID => ({
	type: DELETE_CHILD_LIBRARY,
	libraryID,
});

export const addGroupsToLibrary = (libraryID, groups) => ({
	type: ADD_GROUPS_TO_LIBRARY,
	libraryID,
	groups,
});

export const removeGroupsFromLibrary = (libraryID, groupIDs) => ({
	type: REMOVE_GROUPS_FROM_LIBRARY,
	libraryID,
	groupIDs,
});

export const thunkFetchLibrary = (libraryID, from) => async (dispatch, getState) => {
	const client = makeApolloClient(getState());
	try {
		const { library } = await client.request(LIBRARY, {
			id: libraryID,
		});
		dispatch(fetchLibrary(library, from));
	} catch (error) {
		dispatch(fetchLibrary({ error: 'Library no longer exists' }));
		logError(error, 'library.actions.thunkFetchLibrary');
	}
};

export const thunkFetchAttendeeMaterials = (eventID, from) => async (dispatch, getState) => {
	const client = makeApolloClient(getState());
	try {
		const { attendeeMaterialsLibrary } = await client.request(ATTENDEE_MATERIALS_LIBRARY, {
			event_id: eventID,
		});
		dispatch(fetchLibrary(attendeeMaterialsLibrary, from));
	} catch (error) {
		logError(error, 'library.actions.thunkFetchAttendeeMaterials');
	}
};

export const thunkSearchLibraryForContent = (libraryID, searchTerm, from) => async (
	dispatch,
	getState
) => {
	const client = makeApolloClient(getState());
	try {
		const { libraryMediaContent } = await client.request(LIBRARY_MEDIA_CONTENT, {
			library_id: libraryID,
			search_term: searchTerm,
		});
		dispatch(fetchLibrary(libraryMediaContent, from));
	} catch (error) {
		logError(error, 'library.actions.thunkSearchLibraryForContent');
	}
};
